<template>
    <div>
        <div v-if="selected_bank">
            <h3 class="mb-0">Mortgage Details</h3>
            <b-form role="form" class="mt-4" >
                <b-row>
                    <b-col md="8" cols="12">
                        <b-form-group label="Bank Selected">
                            <el-image style="height: 20px;" :src="selected_bank.bank_image_url" fit="contain">
                            <template #error>
                                    <div class="image-slot">
                                        <span class="d-inline-block text-truncate" style="max-width: 90px;">{{ selected_bank.bank_name }}</span>
                                    </div>
                                </template>
                            </el-image>
                        </b-form-group>
                    </b-col>
    
                    <b-col md="8" cols="12">
                        <b-form-group label="Types of Property Sales">
                            <el-select v-model="form.property_type" placeholder="Select">
                                <el-option
                                    v-for="(type, index) in propertyOptions"
                                    :key="index"
                                    :label="type.label"
                                    :value="type.value"
                                ></el-option>
                            </el-select>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Project Name">
                            <b-form-input
                                v-model="form.project_name"
                                type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Unit No">
                            <b-form-input
                                v-model="form.unit_no"
                                type="text"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
    
                    <b-col md="8" cols="12">
                        <b-form-group label="SPA Price">
                            <b-form-input
                                v-model="form.spa_price"
                                type="number"
                                step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
    
                    <b-col md="8" cols="12">
                        <b-form-group label="Loan Margin (%)">
                            <b-form-input
                                v-model="form.loan_margin"
                                type="number"
                                step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
    
                    <b-col md="8" cols="12" class="mb-2">
                        <b-form-group label="Loan Amount (RM)"  class="mb-2">
                            <b-form-input
                                v-model="form.loan_amount"
                                type="number"
                                step="0.01"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-checkbox
                        class="text-muted"
                        v-model="is_use_loan_amount"
                        >
                        Override
                        </b-form-checkbox>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Interest Rate">
                            <b-form-input
                                v-model="form.interest_per_annum"
                                type="number"
                                step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                     
                    <b-col md="8" cols="12">
                        <b-form-group label="Tenure Year">
                            <b-form-input
                                v-model="form.tenure_year"
                                type="number"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
                    <b-col md="8" cols="12">
                        <b-form-group label="Installment (RM)">
                            <b-form-input
                                v-model="installment"
                                type="number"
                                step="0.01"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
    
                    <b-col cols="12"  v-if="checkAppCode('sas')">
                        <h3 class="mb-4">Arrangement Fee</h3>
                    </b-col>
    
                    <b-col md="8" cols="12" v-if="checkAppCode('sas')">
                        <b-form-group label="Arrangement Fee Amount">
                            <b-form-input
                            v-model="form.arrangement_fee"
                            type="number"
                            step="0.01"
                              ></b-form-input>
                        </b-form-group>
                    </b-col>
                        
                    <b-col md="8" cols="12" v-if="checkAppCode('sas')">
                        <b-form-group label="Arrangement Fee SST">
                            <b-form-radio-group
                                v-model="form.arrangement_fee_sst"
                                :options="SST_OPTIONS"
                            ></b-form-radio-group>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12" v-if="checkAppCode('sas')">
                        <b-form-group label="Total Arrangement Fee (RM)">
                            <b-form-input
                            v-model="form.arrangement_fee_amount"
                            type="text"
                            required
                            disabled
                            placeholder="0.00"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    
    
                    <b-col md="8" cols="12">
                        <b-button block variant="primary" class="mb-5" @click.prevent="saveMortgage">
                            <span v-if="!existing_mortgage">Proceed</span>
                            <span v-else>Add</span>
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
        <p class="text-center" v-else>Please select a bank.</p>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton, Image } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import { mapActions, mapState } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import {
    calculateLoanMargin,
  calculateInstallment, 
  calculateLoanAmount
} from '@/assets/js/calculator.js'
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import {SST_OPTIONS} from '@/assets/js/options.js'

export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
        [Image.name]: Image,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
        return {
            existing_mortgage:null,
            selected_bank: null,
            form: {
                project_name: '',
                unit_no: '',
                property_type : '',
                spa_price: '',
                loan_margin: 90,
                loan_amount: '',
                interest_per_annum: '',
                tenure_year: '',
                installment: '',
                arrangement_fee: 0,
                arrangement_fee_any_amount: 0,
                arrangement_fee_amount: 0,
                arrangement_fee_sst: 0,
            },
            is_use_loan_amount:false,
            propertyOptions: [
                {
                    value: 'Developer',
                    label: 'Developer'
                },
                {
                    value: 'Sub Sales',
                    label: 'Sub Sales'
                },
                {
                    value: 'Auction',
                    label: 'Auction'
                },
            ],
            SST_OPTIONS: SST_OPTIONS,
        }
    },
    watch: {
        '$route.query.product_id':{
            handler(newVal){
                if(this.current_product_type === 'mortgage'){
                    const productData = this.mortgage_draft_products.find((item) => item.prod_id == newVal)
                    if(productData){
                        this.existing_mortgage = productData
                       this.form.project_name = productData.product_detail.prod_pm_project_name
                       this.form.unit_no = productData.product_detail.prod_pm_unit_no
                       this.form.property_type = productData.product_detail.prod_pm_property_type
                       if(productData.product_banks.length > 0){
                           this.form.spa_price = productData.product_banks[0].prod_bnk_spa_amount
                       }
                    }
                }
            },
            immediate: true
        },
        'current_product_data':{
            handler(newVal){
                if(this.current_product_type === 'mortgage'){
                    if(newVal.hasOwnProperty('banks')){
                        this.selected_bank = newVal.banks[0]
                        this.form.interest_per_annum = newVal.banks[0].bank_loan_interest_rate
                        this.form.tenure_year = newVal.banks[0].bank_loan_tenure_year
                    }
                }
            },
        },
        'form':{
            handler(newVal){
                if(newVal){
                    if(this.is_use_loan_amount){
                        this.form.loan_margin = calculateLoanMargin(newVal.loan_amount, newVal.spa_price)
                    }else{
                        this.form.loan_amount = calculateLoanAmount(newVal.spa_price, newVal.loan_margin)
                    }

                    let sst_fee = parseFloat(this.form.arrangement_fee) * parseFloat(this.form.arrangement_fee_sst) / 100
                    //set total arragement fee
                    let arrangement_fee_amount = parseFloat(this.form.arrangement_fee) + parseFloat(sst_fee)
                    if(isNaN(arrangement_fee_amount)){
                        this.form.arrangement_fee_amount = 0
                    }else{
                        this.form.arrangement_fee_amount = arrangement_fee_amount
                    }
                }
            },
            deep: true
        }
    },
    computed: {
        ...mapState(useProductStore, ['current_product_data', 'current_product_type', 'mortgage_draft_products']),
        installment:{
            get(){
                return calculateInstallment(this.form.loan_amount, this.form.interest_per_annum, this.form.tenure_year)
            },
            set(val){
                this.form.installment = val
            }
        }
    },
    methods: {
        ...mapActions(useProductStore, ['createMortgageProduct', 'getCustomerProducts']),
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        async saveMortgage() {
            if(!this.form.property_type){
                this.errorFunction(null, 'Please select property type')
                return
            }

            if(!this.form.spa_price){
                this.errorFunction(null, 'Please enter SPA price')
                return
            }

            if(!this.form.project_name){
                this.errorFunction(null, 'Please enter Project name')
                return
            }

            const mortgage = {
                mortgage_type: this.form.property_type,
                mortgage_spa_price: this.form.spa_price,
                mortgage_loan_margin: this.form.loan_margin,
                mortgage_loan_amount: this.form.loan_amount,
                mortgage_interest_rate: this.form.interest_per_annum,
                mortgage_tenure_year: this.form.tenure_year,
                mortgage_installment: this.installment,
                mortgage_arrangement_fee: this.form.arrangement_fee,
                mortgage_arrangement_sst_fee: this.form.arrangement_fee_sst,
                mortgage_arrangement_amount: this.form.arrangement_fee_amount,
                mortgage_project_name: this.form.project_name,
                mortgage_unit_no: this.form.unit_no,
            }

            // CHECK IF ADDING NEW BANK OR CREATE NEW MORTGAGE
            if(this.existing_mortgage){
                try{
                    await this.addMortgageAdditionalBank(mortgage)
                    this.notifySuccess('<b>Bank </b> - Successfully Added.')
                    this.resetField()
                    // remove product id once added bank
                    const currentQuery = { ...this.$route.query };
                    delete currentQuery.product_id;
                    this.$router.replace({query: currentQuery,},() => {})

                    solutionEventBus.$emit('show-mortgage-summary')
                }catch(e){
                    this.errorFunction(null, e)
                }
            }else{
                useProductStore().$patch((state) => {
                    state.current_product_data = { 
                        ...state.current_product_data, 
                        mortgage: mortgage
                    }
                })
    
                try{
                    await this.createMortgageProduct()
                    this.notifySuccess('<b>Draft </b> - Successfully Created.')
                    this.resetField()
                    solutionEventBus.$emit('show-mortgage-summary')
                }catch(e){
                    this.errorFunction(null, e)
                }
            }
        },
        resetField(){
            this.selected_bank = null
            this.existing_mortgage = null
            this.form.project_name = ''
            this.form.unit_no = ''
            this.form.property_type  = ''
            this.form.spa_price = ''
            this.form.loan_margin = 90
            this.form.loan_amount = ''
            this.form.interest_per_annum = ''
            this.form.tenure_year = ''
            this.form.installment = ''
            this.form.arrangement_fee = 0
            this.form.arrangement_fee_any_amount = 0
            this.form.arrangement_fee_amount = 0
            this.form.arrangement_fee_sst = 0
        },
        async addMortgageAdditionalBank(mortgage){
            let bankData = {
                "prod_bnk_prod_id": this.existing_mortgage.prod_id,
                "prod_bnk_name": this.selected_bank.bank_name,
                "prod_bnk_logo_url": this.selected_bank.bank_image_url,
                "prod_bnk_provider_id": null,
                "prod_bnk_stage_status":"Pending Submission",
                "prod_bnk_loan_amount": mortgage.mortgage_loan_amount,
                "prod_bnk_spa_amount": mortgage.mortgage_spa_price,
                "prod_bnk_interest": mortgage.mortgage_interest_rate,
                "prod_bnk_margin": mortgage.mortgage_loan_margin,
                "prod_bnk_tenure": mortgage.mortgage_tenure_year,
                "prod_bnk_gross_cashback": null,
                "prod_bnk_installment": mortgage.mortgage_installment,
                "prod_bnk_code": this.selected_bank.bank_code,
                "prod_bnk_agreement_rate": this.form.arrangement_fee,
                "prod_bnk_agreement_rate_sst": this.form.arrangement_fee_sst,
                "prod_bnk_agreement_fees": this.form.arrangement_fee_amount,
            }

            const res = await axios.post(services.product + 'product-bank', bankData, {headers: getHeader()})
            this.getCustomerProducts(this.existing_mortgage.prod_customer_id)
        }
    }
}
</script>